import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import { firebaseConfig } from "./firebase.config";

firebase.initializeApp(firebaseConfig);

export const signInWithGoogle = () => {
    const provider = new firebase.auth.GoogleAuthProvider();
    return firebase.auth().signInWithPopup(provider)
        .then(result => {
            const { email, displayName, photoURL } = result.user;
            const newUser = {
                email: email,
                displayName: displayName,
                photoURL: photoURL
            }
            return newUser;
        })
}

export const firebaseIdToken = () => {
    return firebase.auth().currentUser.getIdToken(true)
        .then(idToken => {
            return idToken;
        })
        .catch(error => {
            return error;
        });
}